/**
 * Per-page document titles: "Page · App". i18n.ts resets document.title to
 * the bare app title on language change; this hook re-applies the page part
 * afterwards (it re-runs on language change) and restores the bare title on
 * unmount.
 */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function usePageTitle(titleKey: string): void {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  useEffect(() => {
    document.title = `${t(titleKey)} · ${t("app.title")}`;
    return () => {
      document.title = t("app.title");
    };
  }, [t, titleKey, language]);
}
